import { Sk } from './shared';

const FILES = [{ words: '2,104 w' }, { words: '1,340 w' }, { words: '882 w' }];

export function MkLegalDoc() {
  return (
    <div className="csmk csmk-legaldoc">
      <div className="ld-files">
        {FILES.map((f, i) => (
          <div className="ld-file" key={i}>
            <span className="chk" />
            <span className="finfo">
              <span className="fname" />
              <span className="words">{f.words}</span>
            </span>
          </div>
        ))}
      </div>
      <div className="ld-doc">
        <div className="ld-tools">
          <span className="tg b">B</span>
          <span className="tg i">I</span>
          <span className="tg u">U</span>
          <span className="tdiv" />
          <span className="tg">H1</span>
          <span className="tg">¶</span>
        </div>
        <div className="ld-body">
          <div className="ld-h">Contract of Service</div>
          <Sk w="94%" h="6px" /><Sk w="100%" h="6px" /><Sk w="76%" h="6px" />
          <Sk w="88%" h="6px" /><Sk w="100%" h="6px" /><Sk w="60%" h="6px" />
        </div>
      </div>
      <div className="ld-ai">
        <div className="ld-aihd"><span className="bot" /> Anywhere AI</div>
        <div className="ld-msgs">
          <div className="msg"><Sk w="100%" h="6px" /><Sk w="82%" h="6px" /></div>
          <div className="msg reply"><Sk w="90%" h="6px" /></div>
        </div>
        <div className="ld-input">Ask me to modify the document…</div>
      </div>
    </div>
  );
}
